import { default as aboutpRLO4ZTdYqMeta } from "/home/philip/work/general/clifton-bootcamp/pages/about.vue?macro=true";
import { default as classespFbjgbFaH8Meta } from "/home/philip/work/general/clifton-bootcamp/pages/classes.vue?macro=true";
import { default as contactiByMjgVF1eMeta } from "/home/philip/work/general/clifton-bootcamp/pages/contact.vue?macro=true";
import { default as indexnxG6DDBzDWMeta } from "/home/philip/work/general/clifton-bootcamp/pages/index.vue?macro=true";
import { default as partners53aGHyGosfMeta } from "/home/philip/work/general/clifton-bootcamp/pages/partners.vue?macro=true";
import { default as pricingL4I5MSb2voMeta } from "/home/philip/work/general/clifton-bootcamp/pages/pricing.vue?macro=true";
import { default as privacy_45policysjDFdDbW4HMeta } from "/home/philip/work/general/clifton-bootcamp/pages/privacy-policy.vue?macro=true";
import { default as terms_45and_45conditionsl0DybdEueHMeta } from "/home/philip/work/general/clifton-bootcamp/pages/terms-and-conditions.vue?macro=true";
import { default as timetablesIhiby5bLZMeta } from "/home/philip/work/general/clifton-bootcamp/pages/timetable.vue?macro=true";
import { default as component_45stub5uPyLsmyMEMeta } from "/home/philip/work/general/clifton-bootcamp/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5uPyLsmyME } from "/home/philip/work/general/clifton-bootcamp/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/about.vue")
  },
  {
    name: "classes",
    path: "/classes",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/classes.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/contact.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/index.vue")
  },
  {
    name: "partners",
    path: "/partners",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/partners.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/pricing.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/privacy-policy.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/terms-and-conditions.vue")
  },
  {
    name: "timetable",
    path: "/timetable",
    component: () => import("/home/philip/work/general/clifton-bootcamp/pages/timetable.vue")
  },
  {
    name: component_45stub5uPyLsmyMEMeta?.name,
    path: "/lander",
    component: component_45stub5uPyLsmyME
  }
]